import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const ScheduleListItem = ({
   borderTop,
   date,
   editUrl,
   endTime,
   includeDate,
   location,
   name,
   onRemoveButtonClick,
   startTime
}) => (
   <View
      display="flex"
      alignItems="flex-start"
      padding="12px 24px"
      borderTop={borderTop}>
      <View
         width="150px"
         flex="0 0 auto">
         {includeDate && (
            <Text color="#888" size="1" weight="medium">
               {date}
            </Text>
         )}
         <Text color="#888" size="1" weight="medium" transform="uppercase">
            {`${startTime} ${endTime ? `- ${endTime}` : ''}`}
         </Text>
      </View>
      <View flex="1 1 auto">
         <Text size="2" weight="medium" color="#111">
            {name}
         </Text>
         {location && (
            <Text size="1" color="#888">
               {location}
            </Text>
         )}
      </View>
      <View flex="0 0 auto">
         <Text size="1" weight="medium" color="#666">
            <Link to={editUrl}>
               <View display="inline-block" padding="0 18px">
                  <u style={{ color: '#666' }}>Edit</u>
               </View>
            </Link>
            <View
               onClick={onRemoveButtonClick}
               display="inline-block"
               style={{ cursor: 'pointer' }}>
               <u>Remove</u>
            </View>
         </Text>
      </View>
   </View>
)

ScheduleListItem.propTypes = {
   borderTop: PropTypes.string,
   date: PropTypes.string,
   editUrl: PropTypes.string.isRequired,
   endTime: PropTypes.string,
   includeDate: PropTypes.bool.isRequired,
   location: PropTypes.string,
   name: PropTypes.string.isRequired,
   onRemoveButtonClick: PropTypes.func.isRequired,
   startTime: PropTypes.string.isRequired
}

ScheduleListItem.defaultProps = {
   borderTop: '1px solid #eee',
   date: undefined,
   endTime: undefined,
   location: undefined
}

export default ScheduleListItem
